/* Home-only accessibility glue; no changes to Klaviyo submissions or offers. */
(() => {
  if (!document.body.classList.contains('template-index')) return;

  document.addEventListener('keydown', event => {
    const tab = event.target.closest('.tabbed-collections [role="tab"]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    const current = tabs.indexOf(tab);
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    tabs[index].click();
    tabs[index].focus({preventScroll:true});
    tabs[index].scrollIntoView({block:'nearest',inline:'nearest'});
  });
  document.addEventListener('click', event => {
    const tab = event.target.closest('.tabbed-collections [role="tab"]');
    if (!tab) return;
    tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]').forEach(item => item.tabIndex = item === tab ? 0 : -1);
  });

  /* Progressive excerpts: the full customer text stays in one DOM node.
     Without JavaScript the complete testimonials remain readable. */
  const resizeCarousel = slider => {
    const instance = window.Flickity?.data(slider);
    if (instance) instance.resize();
  };
  const refreshReviews = slider => {
    slider.querySelectorAll('[data-home-review-copy]').forEach(copy => {
      if (!copy.getBoundingClientRect().width) return;
      const button = copy.parentElement.querySelector('[data-home-review-toggle]');
      const expanded = button.getAttribute('aria-expanded') === 'true';
      copy.dataset.enhanced = 'true';
      copy.classList.add('is-collapsed');
      const truncated = copy.scrollHeight > copy.clientHeight + 1;
      button.hidden = !truncated;
      if (expanded && truncated) copy.classList.remove('is-collapsed');
      if (!truncated) {
        button.setAttribute('aria-expanded','false');
        if (button.textContent !== 'Lire la suite') button.textContent = 'Lire la suite';
      }
    });
    resizeCarousel(slider);
  };
  const setupReviews = () => {
    document.querySelectorAll('.testimonials-slider:has([data-home-review-copy])').forEach(slider => {
      if (slider.dataset.excerptsReady) return;
      slider.dataset.excerptsReady = 'true';
      const visible = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setTimeout(() => refreshReviews(slider),100);
          visible.disconnect();
        }
      },{rootMargin:'500px'});
      visible.observe(slider);
      let previousWidth = -1;
      const sizing = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (Math.abs(width-previousWidth)>0.5) {
          previousWidth=width;
          requestAnimationFrame(()=>refreshReviews(slider));
        }
      });
      sizing.observe(slider);
      slider.addEventListener('click',event=>{
        const button=event.target.closest('[data-home-review-toggle]');
        if (!button) return;
        const copy=document.getElementById(button.getAttribute('aria-controls'));
        const expanded=button.getAttribute('aria-expanded')!=='true';
        button.setAttribute('aria-expanded',String(expanded));
        button.textContent=expanded?'Réduire':'Lire la suite';
        copy.classList.toggle('is-collapsed',!expanded);
        const instance=window.Flickity?.data(slider);
        if (instance) {
          instance.selectCell(button.closest('.testimonials-slide'),false,true);
          instance.resize();
        }
      });
      refreshReviews(slider);
    });
  };
  setupReviews();
  document.fonts.ready.then(()=>document.querySelectorAll('.testimonials-slider[data-excerpts-ready]').forEach(refreshReviews));
  document.addEventListener('shopify:section:load',setupReviews);

  /* App headings belong to their dialog, below the page's editorial H1.
     ARIA levels preserve React-owned nodes and all the form event handlers. */
  const normalizePopup = () => {
    document.querySelectorAll('[aria-label="POPUP Form"] h1').forEach(heading => {
      heading.setAttribute('role','heading');
      heading.setAttribute('aria-level','2');
    });
    document.querySelectorAll('[aria-label="POPUP Form"] button.klaviyo-form-button').forEach(button => {
      if (button.textContent.trim() === 'Je veux ma réduction') button.textContent = 'Obtenir ma réduction';
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled=false; normalizePopup(); });
  });
  observer.observe(document.body,{childList:true,subtree:true});
  normalizePopup();
})();
